module.exports = __webpack_public_path__ + "static/media/bez_temp_w_domu_chlodzenie_1.6ffb0db4.svg";